import PayrollCountdownBanner from './PayrollCountdownBanner';

export default PayrollCountdownBanner;
